import React from 'react'
import { observer } from 'mobx-react'
import useCollection from '../hooks/use-collection'

function WhenCollectionIsEmpty (props) {
  const collection = useCollection()

  if (collection && collection.length && collection.length > 0) {
    return null
  }

  if (React.Children.count(props.children) === 0) {
    return null
  }

  return props.children
}

export default observer(WhenCollectionIsEmpty)
